import React from 'react';

import { useBoolean } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import trimText from './utils';

const ViewButton = styled(Button)`
  display: inline;
  color: #1565bc;
  font-size: inherit;
  font-weight: inherit;
  height: auto;
  padding: 0;
  vertical-align: baseline;
  p {
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
  }
`;

const ViewMore = ({ as, min, max, ideal, text }) => {
  const [primaryText, secondaryText] = trimText({ text, min, max, ideal });

  const [showSecondaryText, setShowSecondaryText] = useBoolean();

  const TextComp = as ?? TextBodyMedium;
  return (
    <TextComp whiteSpace="pre-line">
      {primaryText}{' '}
      <>
        {secondaryText && !showSecondaryText ? (
          <ViewButton variant="tertiary" onClick={setShowSecondaryText.on}>
            View more
          </ViewButton>
        ) : (
          <>
            {secondaryText}
            {secondaryText && showSecondaryText ? (
              <ViewButton variant="tertiary" onClick={setShowSecondaryText.off}>
                View less
              </ViewButton>
            ) : null}
          </>
        )}
      </>
    </TextComp>
  );
};

export default ViewMore;
